import React from "react"
import "bootstrap/dist/css/bootstrap.css"
import "./src/styles/app.scss"
import LanguageProvider from "./src/components/LanguageProvider"

export const wrapPageElement = ({ element, props }) => (
  <LanguageProvider pageContext={props.pageContext}>{element}</LanguageProvider>
)

/**
 * Fire page_view after Helmet has committed document.title so GA/GTM
 * do not race an empty title on client navigations.
 *
 * page_view owner for on-page gtag: this callback (explicit page_title).
 * mango-core gtag config uses send_page_view: false so it does not auto-send.
 * GTM container auto-pageviews are configured in the GTM UI, not here.
 * dataLayer `gatsby_route_update` is for a GTM trigger if/when added.
 *
 * One rAF is enough to run after Helmet's DOM commit.
 */
export const onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined") return

  const sendPageView = () => {
    const page_title = document.title
    if (!page_title) return

    const page_path = `${location.pathname}${location.search || ""}`
    const page_location = window.location.href

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "gatsby_route_update",
      page_title,
      page_path,
      page_location,
    })

    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_title,
        page_path,
        page_location,
      })
    }
  }

  window.requestAnimationFrame(sendPageView)
}
